import { render, staticRenderFns } from "./ExamQuestions.vue?vue&type=template&id=b97aeac0"
import script from "./ExamQuestions.vue?vue&type=script&lang=js"
export * from "./ExamQuestions.vue?vue&type=script&lang=js"
import style0 from "./ExamQuestions.vue?vue&type=style&index=0&id=b97aeac0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports